import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import BuzzShell from "./BuzzShell";

export default function BuzzSettings() {
  const { t } = useTranslation();
  const [s, setS] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/buzz/settings`).then(r => setS(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    await axios.put(`${config.API_BASE_URL}/buzz/settings`, s);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const uploadLogo = async (file) => {
    const fd = new FormData();
    fd.append("logo", file);
    await axios.post(`${config.API_BASE_URL}/buzz/settings/logo`, fd);
    setS({ ...s, has_logo: 1 });
  };

  if (!s) return <BuzzShell><div className="bz-empty">…</div></BuzzShell>;

  return (
    <BuzzShell>
      <div className="bz-card">
        <h4 style={{ marginBottom: 4 }}>🏪 {t("Your venue")}</h4>
        <p className="bz-hint" style={{ marginBottom: 6 }}>
          {t("What guests see when they scan the QR.")}
        </p>
        <div className="bz-form-row">
          <label>{t("Business name (shown to guests)")}</label>
          <input type="text" value={s.brand_name || ""} maxLength={60}
            onChange={e => setS({ ...s, brand_name: e.target.value })} />
        </div>
        <div className="bz-form-row">
          <label>{t("Logo")}</label>
          <input type="file" accept="image/*" onChange={e => e.target.files[0] && uploadLogo(e.target.files[0])} />
          {s.has_logo ? <span className="bz-chip">✓</span> : null}
        </div>
        <div className="bz-form-row">
          <label>{t("Guest page language")}</label>
          <select value={s.default_lang} onChange={e => setS({ ...s, default_lang: e.target.value })}>
            <option value="el">Ελληνικά</option>
            <option value="en">English</option>
          </select>
        </div>
      </div>

      <div className="bz-card">
        <h4 style={{ marginBottom: 4 }}>⚙️ {t("How calls work")}</h4>
        <p className="bz-hint" style={{ marginBottom: 6 }}>
          {t("Timing and QR behaviour. The defaults work for most venues.")}
        </p>
        <div className="bz-form-row">
          <label>{t("QR mode")}</label>
          <select value={s.qr_mode} onChange={e => setS({ ...s, qr_mode: e.target.value })}>
            <option value="static">{t("Static — printed per table")}</option>
            <option value="dynamic">{t("Dynamic — staff gives QR per guest")}</option>
            <option value="both">{t("Both")}</option>
          </select>
        </div>
        {s.qr_mode !== "static" && (
          <div className="bz-form-row">
            <label>{t("Guest QR duration (hours)")}</label>
            <input type="number" min="1" max="24" value={s.session_hours}
              onChange={e => setS({ ...s, session_hours: e.target.value })} />
          </div>
        )}
        <div className="bz-form-row">
          <label>{t("Cooldown between calls (sec)")}</label>
          <input type="number" min="10" max="600" value={s.cooldown_sec}
            onChange={e => setS({ ...s, cooldown_sec: e.target.value })} />
        </div>
        <div className="bz-form-row">
          <label>{t("Call expires after (min)")}</label>
          <input type="number" min="2" max="60" value={s.expire_min}
            onChange={e => setS({ ...s, expire_min: e.target.value })} />
          <span className="bz-hint">{t("Expired calls count as missed in reports.")}</span>
        </div>
      </div>

      <div className="bz-card">
        <h4 style={{ marginBottom: 4 }}>⭐ {t("Guest feedback")}</h4>
        <p className="bz-hint" style={{ marginBottom: 6 }}>
          {t("After a call is served, guests can rate the service on their phone.")}
        </p>
        <div className="bz-form-row">
          <label>{t("Guest feedback")}</label>
          <input type="checkbox" checked={!!s.feedback_enabled}
            onChange={e => setS({ ...s, feedback_enabled: e.target.checked })} />
        </div>
        {!!s.feedback_enabled && (
          <div className="bz-form-row">
            <label>{t("Google review link")}</label>
            <input type="url" placeholder="https://g.page/r/..." value={s.google_review_url || ""}
              onChange={e => setS({ ...s, google_review_url: e.target.value })} />
            <span className="bz-hint">{t("Suggested to 5-star guests only.")}</span>
          </div>
        )}
      </div>

      <div className="bz-toolbar">
        <button className="bz-btn primary" onClick={save}>
          {saved ? "✓ " + t("Saved") : t("Save")}
        </button>
        {saved && <span className="bz-hint">{t("Changes are live for guests immediately.")}</span>}
      </div>
    </BuzzShell>
  );
}
